import React from 'react';
import Aboutus from '../assets/Aboutus.jpg';
import abs from '../assets/luxury.jpeg';
import { Link } from 'react-router-dom';
import { Heart as HeartIcon, Users, Leaf } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-cream">

      {/* HERO */}
      {/* <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
       <img
          src={abs}
          alt="About Siyaanish"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-charcoal/50"></div>

        <div className="relative text-center text-white px-6">
          <div className="bg-black/40 backdrop-blur-sm px-8 py-6 rounded-lg inline-block">
            <h1 className="font-serif text-5xl md:text-7xl mb-4">
              Siyaanish
            </h1>
            <p className="text-lg font-light">
              Luxury that breathes. Ethics that matter.
            </p>
          </div> 
        </div>
      </section> */}

      {/* SHORT LUXURY VERSION */}
      <section className="py-24 max-w-4xl mx-auto px-6 text-center">
        <p className="text-lg text-[#6B665F] font-light mb-6">
          Siyaanish began with a quiet awakening — the moment beauty could no longer exist without conscience.
        </p>

        <p className="text-[#6B665F] font-light mb-6">
          Siyaanish is a conscious lifestyle and fashion label rooted in eco-friendly, natural,
          and breathable fabrics, thoughtfully sourced and ethically produced.
          We believe that what touches the skin should honour life.
        </p>

        <p className="text-[#6B665F] font-light mb-6">
          Our focus is on plant-based and natural materials — many derived from agricultural
          and plant waste — that are gentle, breathable, and adaptive to the body.
        </p>

        <p className="text-[#6B665F] font-light">
          Each Siyaanish piece is created in small batches. No two pieces are alike,
          because nature itself does not repeat.
        </p>

        <p className="mt-10 font-serif text-xl text-charcoal">
          Siyaanish is not trend-led. It is value-led.
        </p>
      </section>

      {/* VALUES */}
      <section className="py-24 bg-white">
        <h2 className="font-serif text-4xl text-center text-charcoal mb-16">
          Our Values
        </h2>

        <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto px-6 text-center">
          <div>
            <Leaf size={60} className="mx-auto text-bronze mb-4" />
            <h3 className="font-serif text-2xl mb-2">Natural</h3>
            <p className="text-[#6B665F] font-light">
              Plant-based and breathable materials sourced with intention.
            </p>
          </div>

          <div>
            <HeartIcon size={60} className="mx-auto text-bronze mb-4" />
            <h3 className="font-serif text-2xl mb-2">Ethical</h3>
            <p className="text-[#6B665F] font-light">
              Conscious craftsmanship, transparency, and fairness.
            </p>
          </div>

          <div>
            <Users size={60} className="mx-auto text-bronze mb-4" />
            <h3 className="font-serif text-2xl mb-2">Intentional</h3>
            <p className="text-[#6B665F] font-light">
              Small batches. No excess. Purpose over impulse.
            </p>
          </div>
        </div>
      </section>

      {/* FOUNDER NOTE */}
     <section className="py-24 bg-beige">
  <div className="max-w-4xl mx-auto px-6 text-center">
    <h2 className="font-serif text-3xl mb-6 text-charcoal">
      Founder’s Note
    </h2>

    <p className="text-[#6B665F] font-light mb-4">
      I grew up admiring luxury — but not questioning it. Learning how fabrics were
      sourced made me uncomfortable with the hidden cost behind beauty.
    </p>

    <p className="text-[#6B665F] font-light mb-4">
      While studying Management & Contemporary Brand Management in London,
      I discovered a new definition of luxury — rooted in ethics and long-term impact.
    </p>

    <p className="text-[#6B665F] font-light">
      Siyaanish is not about producing more. It is about producing better.
    </p>

    <p className="italic mt-6 text-charcoal">
      — Founder, Siyaanish
    </p>
  </div>
</section>

      {/* MANIFESTO */}
      <section className="py-24 text-center max-w-3xl mx-auto px-6">
        <p className="text-[#6B665F] font-light leading-loose">
          We believe beauty should never harm.<br/>
          We choose natural over synthetic.<br/>
          Values over volume.<br/>
          Ethics over excess.<br/>
          We honour imperfections.<br/>
          Siyaanish is not fast fashion.<br/>
          It is conscious creation.
        </p>

        <p className="font-serif text-xl text-charcoal mt-10">
          Live your values. Wear them too.
        </p>
      </section>

      {/* PRESS / MEDIA STORY */}
      {/* <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="font-serif text-4xl text-charcoal mb-10 text-center">
            Press & Media
          </h2>

          <img
            src="https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=1600&q=80"
            alt="Fabric studio"
            className="w-full h-[350px] object-cover mb-10"
          />

          <p className="text-[#6B665F] font-light leading-relaxed mb-4">
            Siyaanish is an India-rooted conscious fashion and lifestyle label focused on eco-friendly,
            natural, and plant-based fabrics. The brand works with ethically sourced materials,
            including fibres derived from agricultural and plant waste.
          </p>

          <p className="text-[#6B665F] font-light leading-relaxed mb-4">
            Founded by a management graduate specialising in contemporary brand management,
            Siyaanish challenges conventional luxury by prioritising ethics, comfort, and sustainability.
          </p>

          <p className="text-[#6B665F] font-light leading-relaxed">
            Producing in limited batches, Siyaanish embraces the natural uniqueness of materials,
            ensuring every piece carries individuality and intention.
          </p>

          <p className="mt-6 font-serif text-lg text-charcoal">
            Siyaanish — Live Your Values
          </p>
        </div>
      </section> */}

      {/* CTA */}
     {/* CTA */}
<section
  className="relative py-20 text-center overflow-hidden"
  style={{ backgroundImage: `url(${abs})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
>
  {/* Dark overlay so text is readable */}
  <div className="absolute inset-0 bg-black/50"></div>

  <div className="relative z-10">
    <h2 className="font-serif text-4xl mb-6 text-white">
      Explore Conscious Luxury
    </h2>
    <Link
      to="/shop"
      className="inline-flex items-center justify-center bg-white text-black px-8 py-3 rounded-lg shadow-md hover:bg-gray-100 hover:shadow-lg transition-all duration-300 text-sm tracking-wide font-medium"
      data-testid="hero-cta-button"
    >
      View Collection
    </Link>
  </div>
</section>

    </div>
  );
};

export default About;